class SystemIds {
  public static Empty = "00000000-0000-0000-0000-000000000000";

  public static All = "11111111-1111-1111-1111-111111111111";

  public static AutoCreated = "22222222-2222-2222-2222-222222222222";
}

export default SystemIds;
